module.exports = __webpack_public_path__ + "img/48_25.68fa78f5.png";